(function($){
    'use strict';

    var $pullout = $('.js-pullout'),
    	$pulloutToggle = $pullout.find('button');

    $pulloutToggle.click(function() {
		$pullout.toggleClass('active');
	});
}(jQuery));